import { Component } from '@angular/core';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';

@Component({
  selector: 'beautyapp-important-info',
  templateUrl: './important-info.component.html',
  styleUrls: ['./important-info.component.scss'],
  imports: [NzTypographyComponent],
})
export class ImportantInfoComponent {
}
